/* eslint-disable camelcase */

export default class MailReport {
	constructor({
		unsubscribe,
		total,
		send_count,
		delivery_count,
		open_count,
		click_count,
		bounce_count,
		soft_bounce_count,
		hard_bounce_count,
		send_unique,
		delivery_unique,
		open_unique,
		click_unique,
		bounce_unique,
		soft_bounce_unique,
		hard_bounce_unique,
		...rest
	}) {
		this._unsubscribe = unsubscribe || 0;
		this._total = total || 0;
		this._sendCount = send_count || 0;
		this._deliveryCount = delivery_count || 0;
		this._openCount = open_count || 0;
		this._clickCount = click_count || 0;
		this._bounceCount = bounce_count || 0;
		this._softBounceCount = soft_bounce_count || 0;
		this._hardBounceCount = hard_bounce_count || 0;
		this._sendUnique = send_unique || 0;
		this._deliveryUnique = delivery_unique || 0;
		this._openUnique = open_unique || 0;
		this._clickUnique = click_unique || 0;
		this._bounceUnique = bounce_unique || 0;
		this._softBounceUnique = soft_bounce_unique || 0;
		this._hardBounceUnique = hard_bounce_unique || 0;
		this._rest = { ...rest } || {};
	}

	getKey() {
		return '';
	}

	getUnsubscribe() {
		return this._unsubscribe;
	}

	getTotal() {
		return this._total;
	}

	getSendCount() {
		return this._sendCount;
	}

	getDeliveryCount() {
		return this._deliveryCount;
	}

	getOpenCount() {
		return this._openCount;
	}

	getClickCount() {
		return this._clickCount;
	}

	getSoftBounceCount() {
		return  this._bounceCount  + this._softBounceCount;
	}

	getHardBounceCount() {
		return this._hardBounceCount;
	}

	getClickLinksCountList() {
		const regex = new RegExp('Click:.+_count$');
		return Object.keys(this._rest)
			.filter(key => key.match(regex))
			.reduce((accumulator, current) => {
				const key = current.split('Click:')[1].split('_count')[0].split('?')[0];
				const regexp = new RegExp("^https:\\/\\/pat\\.weezevent\\.[a-z]*\\/mail\\/online.*");
				if(regexp.test(key)){
					accumulator['Online'] = (accumulator['Online'] || 0) + this._rest[current];
				} else {
					accumulator[key] = (accumulator[key] || 0) + this._rest[current];
				}

				return accumulator;
			}, {});
	}

	getSendUnique() {
		return this._sendUnique;
	}

	getDeliveryUnique() {
		return this._deliveryUnique;
	}

	getOpenUnique() {
		return this._openUnique;
	}

	getClickUnique() {
		return this._clickUnique;
	}

	getSoftBounceUnique() {
		return this._bounceCount + this._softBounceUnique;
	}

	getHardBounceUnique() {
		return this._hardBounceUnique;
	}

	getClickLinksUniqueList() {
		const regex = new RegExp('Click:.+_unique$');
		return Object.keys(this._rest)
			.filter(key => key.match(regex))
			.reduce((accumulator, current) => {
				accumulator[current.split('Click:')[1].split('_unique')[0]] = this._rest[current];
				return accumulator;
			}, {});
	}

	getTotalPercent() {
		return this._total ? 100 : 0;
	}

	getSendPercent() {
		return this._total ? ( (this._sendUnique / this._total) * 100 ) : 0;
	}

	getDeliveryPercent() {
		return this._total ? ( (this._deliveryUnique / this._total) * 100 ) : 0;
	}

	getOpenPercent() {
		return this._total ? ( (this._openUnique / this._total) * 100 ) : 0;
	}

	getClickPercent() {
		return this._total ? ( (this._clickUnique / this._total) * 100 ) : 0;
	}

	getSoftBouncePercent() {
		return this._total ? ( this._softBounceUnique + this._bounceUnique ) / this._total * 100 : 0;
	}

	getHardBouncePercent() {
		return this._total ? ( ( this._hardBounceUnique / this._total ) * 100 ) : 0;
	}
};
